import React from "react";

export default function Text({ onChange, text }) {
  return (
    <input
      className="form-control no-print"
      onChange={({ target: { value } }) => onChange(value)}
      type="text"
      value={text}
    />
  );
}
